<div class="bn-care-plan-editor-row">
  <i
    class="pi bn-care-plan-editor-row__icon"
    [class]="'pi ' + icon() + ' bn-care-plan-editor-row__icon'"
    aria-hidden="true"
  ></i>
  <label class="bn-care-plan-editor-row__label" [attr.for]="inputId()">
    {{ label() }}
    @if (required()) {
      <span aria-hidden="true">*</span>
    }
  </label>
  <div class="bn-care-plan-editor-row__control">
    <ng-content />
  </div>
  <div class="bn-care-plan-editor-row__error">
    <ng-content select="[carePlanEditorError]" />
  </div>
</div>
